import $ from 'jquery'

import * as Model from 'api/model'

export default function InfoPanelLegacy () {
  const currentActiveTab = Model.get('app.drawer.activetabid', null)
  if (currentActiveTab !== 'info') {
    return false
  }
  $('#elt-tabs-mode').hide()
  $('#pozi-drawer-tabs-panel-info-temp').hide()
  $('#elt-tabs-mode').hide()
  $('#elt-tabs').hide()
  $('#pozi-drawer-tabs-panel-info-nothing-selected').hide()
  Model.set('app.drawer.activetabid', 'info')
  window.appObject.hideRoute('')
  return true
}
